import styled from 'styled-components';
const percentageSize = 1.3;

export const InfoContainer = styled.div`
  display: ${({ infoOpen }) => (infoOpen ? 'flex' : 'none')};
  position: absolute;
  width: 100%;
  height: ${({ mapHeight }) => mapHeight};
  background-color: #333333;
  opacity: 95%;
  z-index: 10;
  color: white;
  flex-direction: column;
  /* align-items: flex-end; */
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
`;

export const TitleWrapper = styled.div`
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`;

export const HeaderWrapper = styled.div`
  display: block;
  position: fixed;
  width: 100%;
  background-color: #333333;
  z-index: 2;
`;

export const SeparatorRow = styled.div`
  content: '';
  background-color: #b7b7b7;
  width: 96%;
  margin-left: 2%;
  height: 2px;
  opacity: 80%;
`;

export const InfoWrapper = styled.div`
  padding-top: 50px;
`;

export const InfoTitle = styled.h2`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 24 * percentageSize : 24)}px;
  margin-top: 25px;
  padding-left: 18%;
  padding-right: 18%;
  @media screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const InfoParagraph = styled.p`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  padding-left: 18%;
  padding-right: 18%;
  @media screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const UnorderedList = styled.ul`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  padding-left: 24%;
  padding-right: 18%;
  @media screen and (max-width: 768px) {
    padding-left: 25px;
    padding-right: 10px;
  }
`;

export const ListItem = styled.li``;

export const CloseInfo = styled.button`
  background-color: transparent;
  border: 0px;
  margin-top: 10px;
  padding-right: 1%;
`;

export const CloseInfoIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 18 * percentageSize : 18,
  height: props.fontSizeEnabled ? 18 * percentageSize : 18,
  fill: '#fff'
}))``;

export const Link = styled.a`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  :hover {
    color: #febf00;
  }

  :visited {
    color: #febf00;
  }
`;

export const SVGNewTab = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 14 * percentageSize : 14,
  height: props.fontSizeEnabled ? 14 * percentageSize : 14
}))`
  fill: ${({ isHover }) => (isHover ? '#febf00' : 'whitex')};
  margin-left: 5px;
  margin-right: 5px;
`;
